import { render, staticRenderFns } from "./PeiFuBiaoZhunView.vue?vue&type=template&id=692dd12c&scoped=true"
import script from "./PeiFuBiaoZhunView.vue?vue&type=script&lang=js"
export * from "./PeiFuBiaoZhunView.vue?vue&type=script&lang=js"
import style0 from "./PeiFuBiaoZhunView.vue?vue&type=style&index=0&id=692dd12c&prod&lang=less&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "692dd12c",
  null
  
)

export default component.exports